// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XpcFyRenxtXmUP9u6Mog {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 70vh;
}

.brRc9ls_gO_rOxMGzr4X, .FybBPcuoxWLNApshSUd3, .qspPHz5skr7kznVFEkIb {
  display: grid;
  grid-template-columns: 5fr minmax(100px, 2fr) minmax(100px, 2fr);
  column-gap: 8px;
}
@media (max-width: 1000px) {
  .brRc9ls_gO_rOxMGzr4X, .FybBPcuoxWLNApshSUd3, .qspPHz5skr7kznVFEkIb {
    grid-template-columns: 5fr minmax(60px, 2fr) minmax(70px, 2fr);
  }
}

.qspPHz5skr7kznVFEkIb {
  padding: 16px 32px;
  background-color: rgba(255, 255, 255, 0.0509803922);
}
@media (max-width: 1000px) {
  .qspPHz5skr7kznVFEkIb {
    padding: 16px;
  }
}

.evFocF89Xb_DnCwZMcHD {
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #FBFBFB;
}

.FybBPcuoxWLNApshSUd3 {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1019607843);
  padding: 16px 32px;
}
@media (max-width: 1000px) {
  .FybBPcuoxWLNApshSUd3 {
    padding: 16px;
  }
}

.ifKemxAO64pEdFfgYxf1 {
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #FFFFFF;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1000px) {
  .ifKemxAO64pEdFfgYxf1 {
    font-size: 14px;
  }
}

.FaXf08vaLnf92LuCZ30H {
  display: flex;
  flex-direction: row;
  column-gap: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.xzsyrA6tZ_VJ8UHyC4SF {
  font-weight: 600;
  color: white;
}

.erJPWVjwlGzKa54kOwg6 {
  padding: 4px 8px;
  width: 100px;
  background: linear-gradient(90.48deg, #1D4A6D 8.68%, #45AEFF 146.13%);
}

.jQ5HvghW2fH3jJDhuoMW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 40vh;
  font-family: Bai Jamjuree;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/Components/ExperienceHistory/ExperienceHistory.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gEAAA;EACA,eAAA;AACF;AAAE;EAJF;IAKI,8DAAA;EAGF;AACF;;AAAA;EAEE,kBAAA;EACA,mDAAA;AAEF;AADE;EAJF;IAKI,aAAA;EAIF;AACF;;AADA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAIF;;AADA;EAEE,0DAAA;EACA,kBAAA;AAGF;AAFE;EAJF;IAKI,aAAA;EAKF;AACF;;AAFA;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKF;AAJE;EAVF;IAWI,eAAA;EAOF;AACF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAOF;;AAJA;EACE,gBAAA;EACA,YAAA;AAOF;;AAJA;EACE,gBAAA;EACA,YAAA;EACA,qEAAA;AAOF;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAOF","sourcesContent":[".xpHistoryContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  max-height: 70vh;\r\n}\r\n\r\n.xpHistoryTemplate {\r\n  display: grid;\r\n  grid-template-columns: 5fr  minmax(100px, 2fr) minmax(100px, 2fr);\r\n  column-gap: 8px;\r\n  @media (max-width: 1000px) {\r\n    grid-template-columns: 5fr minmax(60px, 2fr) minmax(70px, 2fr);\r\n  }\r\n}\r\n\r\n.xpHistoryHeader {\r\n  @extend .xpHistoryTemplate;\r\n  padding: 16px 32px;\r\n  background-color: #FFFFFF0D;\r\n  @media (max-width: 1000px) {\r\n    padding: 16px;\r\n  }\r\n}\r\n\r\n.xpHistoryHeaderItem {\r\n  font-family: Bai Jamjuree;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n  color: #FBFBFB;\r\n}\r\n\r\n.xpHistoryRow {\r\n  @extend .xpHistoryTemplate;\r\n  border-bottom: 1px solid #FFFFFF1A;\r\n  padding: 16px 32px;\r\n  @media (max-width: 1000px) {\r\n    padding: 16px;\r\n  }\r\n}\r\n\r\n.xpHistoryRowItem {\r\n  font-family: Bai Jamjuree;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 22px;\r\n  color: #FFFFFF;\r\n  word-break: keep-all;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  @media (max-width: 1000px) {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.xpHistoryRowItemLabelRender {\r\n  display: flex;\r\n  flex-direction: row;\r\n  column-gap: 6px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.xpHistoryRowItemLabelBold {\r\n  font-weight: 600;\r\n  color:white ;\r\n}\r\n\r\n.xpBox {\r\n  padding: 4px 8px;\r\n  width: 100px;\r\n  background: linear-gradient(90.48deg, #1D4A6D 8.68%, #45AEFF 146.13%);\r\n}\r\n\r\n.noHistoryFound {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  min-height: 40vh;\r\n  font-family: Bai Jamjuree;\r\n  font-weight: 400;\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n  color: #FFFFFF;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xpHistoryContainer": `XpcFyRenxtXmUP9u6Mog`,
	"xpHistoryTemplate": `brRc9ls_gO_rOxMGzr4X`,
	"xpHistoryRow": `FybBPcuoxWLNApshSUd3`,
	"xpHistoryHeader": `qspPHz5skr7kznVFEkIb`,
	"xpHistoryHeaderItem": `evFocF89Xb_DnCwZMcHD`,
	"xpHistoryRowItem": `ifKemxAO64pEdFfgYxf1`,
	"xpHistoryRowItemLabelRender": `FaXf08vaLnf92LuCZ30H`,
	"xpHistoryRowItemLabelBold": `xzsyrA6tZ_VJ8UHyC4SF`,
	"xpBox": `erJPWVjwlGzKa54kOwg6`,
	"noHistoryFound": `jQ5HvghW2fH3jJDhuoMW`
};
export default ___CSS_LOADER_EXPORT___;
